import { Box, Skeleton } from '@mui/material';
import { colors } from '@src/styles';
import { skeletonSX } from '../scriptsStyles';

interface ScriptsListSkeletonProps {
  rowCount?: number;
}

const GRID_COLUMNS = 'minmax(220px, 1fr) 200px 104px 116px 160px 160px 120px 56px';

const MIN_ROW_HEIGHT = 50;

const NAME_WIDTHS = ['72%', '58%', '80%', '64%', '50%', '76%', '60%', '68%', '54%', '70%'];

export const ScriptsListSkeleton = ({ rowCount = 10 }: ScriptsListSkeletonProps) => {
  return (
    <Box
      aria-busy="true"
      aria-label="Carregando scripts"
      sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
    >
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        <Box sx={{ minWidth: 760, height: '100%', display: 'flex', flexDirection: 'column' }}>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: GRID_COLUMNS,
              gap: 2,
              alignItems: 'center',
              flexShrink: 0,
              paddingX: 2,
              paddingY: 1.5,
              borderBottom: `1px solid ${colors.brand.line}`,
            }}
          >
            {[46, 80, 64, 84, 70, 86, 48, 0].map((width, index) => (
              <Skeleton key={index} variant="text" width={width} height={14} sx={skeletonSX} />
            ))}
          </Box>
          {Array.from({ length: rowCount }, (_, index) => (
            <Box
              key={index}
              sx={{
                flex: '1 0 0',
                minHeight: MIN_ROW_HEIGHT,
                display: 'grid',
                gridTemplateColumns: GRID_COLUMNS,
                gap: 2,
                alignItems: 'center',
                paddingX: 2,
                borderBottom: index === rowCount - 1 ? 'none' : `1px solid ${colors.brand.line}`,
              }}
            >
              <Skeleton variant="text" width={NAME_WIDTHS[index % NAME_WIDTHS.length]} height={18} sx={skeletonSX} />
              <Skeleton variant="text" width="70%" height={18} sx={skeletonSX} />
              <Skeleton variant="text" width={78} height={16} sx={skeletonSX} />
              <Skeleton variant="text" width={78} height={16} sx={skeletonSX} />
              {[0, 1].map((user) => (
                <Box key={user} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Skeleton variant="circular" width={26} height={26} sx={skeletonSX} />
                  <Skeleton variant="text" width={80} height={16} sx={skeletonSX} />
                </Box>
              ))}
              <Skeleton variant="rounded" width={92} height={22} sx={{ ...skeletonSX, borderRadius: '999px' }} />
              <Skeleton
                variant="rounded"
                width={30}
                height={30}
                sx={{ ...skeletonSX, borderRadius: '8px', ml: 'auto' }}
              />
            </Box>
          ))}
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexShrink: 0,
          paddingX: 2,
          paddingY: 1.25,
          borderTop: `1px solid ${colors.brand.line}`,
        }}
      >
        <Skeleton variant="text" width={90} height={14} sx={skeletonSX} />
        <Box sx={{ display: 'flex', gap: 0.75 }}>
          {[0, 1, 2, 3, 4, 5].map((item) => (
            <Skeleton key={item} variant="rounded" width={28} height={28} sx={{ ...skeletonSX, borderRadius: '7px' }} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};
